import React from "react";
import { PaymentCardLoaderTemplate } from "themes/application/payment/components";

function PaymentCardLoader(props) {
    return <PaymentCardLoaderTemplate {...props} />;
}

export default PaymentCardLoader;
